import React from 'react';
import RotatingLogo from './RotatingLogo';

const LoadingSpinner = ({ 
  size = 'default', 
  text = 'Loading...', 
  showText = true, 
  className = '',
  variant = 'default' // 'default', 'fullscreen', 'inline', 'button'
}) => {
  const sizeMap = {
    small: 32,
    default: 64,
    large: 96,
    xlarge: 128
  };

  const logoSize = sizeMap[size] || sizeMap.default;

  const variants = {
    default: (
      <div className={`flex flex-col items-center justify-center space-y-4 ${className}`}>
        <RotatingLogo size={logoSize} />
        {showText && (
          <p className="text-text-secondary font-medium">{text}</p>
        )}
      </div>
    ),
    
    fullscreen: (
      <div className={`min-h-screen flex flex-col items-center justify-center space-y-6 bg-background ${className}`}>
        <RotatingLogo size={logoSize} />
        {showText && (
          <div className="text-center space-y-2">
            <p className="text-lg font-semibold text-text-primary">{text}</p>
            <p className="text-sm text-text-secondary">Please wait while we load your data</p>
          </div>
        )}
      </div>
    ),
    
    inline: (
      <div className={`flex items-center justify-center space-x-3 ${className}`}>
        <RotatingLogo size={logoSize} />
        {showText && (
          <span className="text-text-secondary">{text}</span>
        )}
      </div>
    ),
    
    button: (
      <div className={`flex items-center justify-center space-x-2 ${className}`}>
        <RotatingLogo size={24} />
        {showText && (
          <span className="text-sm">{text}</span>
        )}
      </div>
    )
  };

  return variants[variant] || variants.default;
};

export default LoadingSpinner; 